
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/49ede54ec2019951006b5b5f2b6ee8fa.jpg)'
        }}
      >
        <link rel="preload" as="image" href="https://readdy.ai/api/search-image?query=White-Caucasian-male-HVAC-technician-in-high-visibility-safety-vest-using-digital-volt-meter-multimeter-testing-modern-air-conditioning-unit-professional-tradesman-with-tools-working-on-residential-HVAC-system-bright-clean-workspace-authentic-workplace-photography-skilled-worker-performing-electrical-diagnostics-on-climate-control-equipment-natural-lighting-realistic-detailed-scene-showing-technical-expertise-and-precision-craftsmanship-high-quality-professional-photography&width=1920&height=1080&seq=hero-hvac-volt-meter-002&orientation=landscape" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-slate-800/70 via-slate-900/65 to-slate-800/70"></div>
      
      <main className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Transform Your HVAC Business<br />
          <span className="text-teal-300">With Faith-Driven Growth</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          Proven strategies and personalized guidance to help small HVAC companies scale with confidence, integrity, and purpose
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('pricing')}
            className="px-8 py-4 bg-teal-600 text-white text-base font-semibold rounded-full hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            Explore Our Programs
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border border-white/30"
          >
            Meet the Team
          </button>
        </div>
      </main>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('about')}
          className="text-white/80 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </header>
  );
}
